import { Trans } from '@lingui/react'
import {
  ButtonGroup,
  TextButton,
} from '@twistopayments/design-system/components/atoms/button'
import {
  Headline,
  HeadlineIcon,
  HeadlineSubtitle,
  HeadlineTitle,
} from '@twistopayments/design-system/components/atoms/headline'
import { BigTwistoIcon } from '@twistopayments/design-system/icons/big'
import { styleUtils } from '@twistopayments/design-system/styles'
import { useRouter } from 'next/router'

import { useCancelFlow } from '@twisto/flow-views/components'

import type { OnModalClose } from '../flow-leave-confirm-modal'
import * as styles from '../flow-leave-confirm-modal.styles'

type Props = {
  onClose: OnModalClose
}

export const PayInNContent = ({ onClose }: Props) => {
  const router = useRouter()
  const sessionId = router.query.sessionId as string
  const cancelFlow = useCancelFlow(sessionId)

  return (
    <div css={styles.modalContent}>
      <Headline>
        <HeadlineIcon>
          <BigTwistoIcon
            color="secondaryMainContrast"
            height="100%"
            width="100%"
          />
        </HeadlineIcon>
        <HeadlineTitle>
          <Trans id="flow.leaveConfirmModal.payInN.title" />
        </HeadlineTitle>
        <HeadlineSubtitle>
          <Trans id="flow.leaveConfirmModal.payInN.subtitle" />
        </HeadlineSubtitle>
      </Headline>

      <ButtonGroup css={[styleUtils.margin.top.xl, styles.buttons]}>
        <TextButton fullWidth color="secondary" onClick={() => onClose()}>
          <Trans id="flow.leaveConfirmModal.payInN.button.stay" />
        </TextButton>
        <TextButton fullWidth onClick={cancelFlow}>
          <Trans id="flow.leaveConfirmModal.payInN.button.leave" />
        </TextButton>
      </ButtonGroup>
    </div>
  )
}
